module.exports = __webpack_public_path__ + "assets/retina_NapoleonDetailed.ed78871ef98194dc34e9bfbdd76b5441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_NapoleonDetailed.png
// module id = 694
// module chunks = 0